/**
 * Restaurant Switcher Module
 *
 * Handles the storefront restaurant switcher component (dev/testing tool).
 * Allows minimizing/maximizing the switcher and persists state to localStorage.
 * Auto-initializes on elements with class "restaurant-switcher".
 *
 * Usage in Twig:
 * <div class="restaurant-switcher">
 *     <div class="bg-white">...content...</div>
 *     <button id="switcher-toggle">🏪</button>
 * </div>
 */

import { $, ready } from '../utils/dom.js';

let switcherElement = null;

/**
 * Toggle the switcher visibility
 */
function toggleSwitcher() {
    const switcher = switcherElement || $('.restaurant-switcher');
    if (!switcher) return;

    const isMinimized = switcher.classList.toggle('minimized');

    // Persist state to localStorage
    try {
        localStorage.setItem('switcherMinimized', isMinimized);
    } catch (e) {
        // localStorage not available, ignore
    }
}

/**
 * Initialize the restaurant switcher
 */
function initRestaurantSwitcher() {
    switcherElement = $('.restaurant-switcher');
    if (!switcherElement) return;

    // Restore minimized state from localStorage
    try {
        const switcherState = localStorage.getItem('switcherMinimized');
        if (switcherState === 'true') {
            switcherElement.classList.add('minimized');
        }
    } catch (e) {
        // localStorage not available, ignore
    }

    // Add click handler to toggle button
    const toggleBtn = $('#switcher-toggle', switcherElement);
    if (toggleBtn) {
        toggleBtn.addEventListener('click', toggleSwitcher);
    }

    // Add click handler to close button (the X in the header)
    const closeBtn = switcherElement.querySelector('button[onclick*="toggleSwitcher"]');
    if (closeBtn) {
        // Remove inline onclick and use our handler
        closeBtn.removeAttribute('onclick');
        closeBtn.addEventListener('click', toggleSwitcher);
    }
}

// Expose globally for legacy onclick handlers
window.toggleSwitcher = toggleSwitcher;

/**
 * Auto-initialize on page load
 */
ready(initRestaurantSwitcher);

/**
 * Manual initialization
 */
export function init() {
    initRestaurantSwitcher();
}

export default {
    init,
    toggle: toggleSwitcher
};
